(function($){
    'use strict';

    var g = 0;

	$('.js-gallery').each(function() {
		var $gallery = $(this),
			$galleryMain = $gallery.find('.js-gallery-main'),
			$galleryNav = $gallery.find('.js-gallery-nav');

		$galleryMain.addClass('js-gallery-main-' + g);
		$galleryNav.addClass('js-gallery-nav-' + g);

		$galleryMain.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			asNavFor: '.js-gallery-nav-' + g,
			dots: false,
			arrows: true,
			centerMode: false,
			mobileFirst: true
		});

		$galleryNav.slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: '.js-gallery-main-' + g,
			dots: false,
			arrows: true,
			centerMode: false,
			mobileFirst: true,
			focusOnSelect: true
		});

		g++;
	});
}(jQuery));